import { useDateHook } from '../../../hook/useDateHook';
import { NumberTicket } from '../../ticket/NumberTicket';
import { QrTicket } from '../../ticket/QrTicket';

export const Ticket = ({
  ticketNo,
}: {
  ticketNo: { ticketNo: number; tnmtScheduleSrl: number };
}) => {
  const { showQrDate } = useDateHook();

  if (showQrDate()) return <QrTicket ticketNo={ticketNo} />;
  return <NumberTicket ticketNo={ticketNo} />;
};
